// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"b3-z","trustedRetailerTooltipWrapper":"c3-z"};